import AppConstants from 'AppConstants';

const PRODUCT_TYPES = AppConstants.PRODUCT_TYPES;
const frameProductType = PRODUCT_TYPES['PHOTO_FRAME'];
const INCH_PER_PIXEL = 16/4800;
    
const FRAME_SIZE_TYPES = ["XXXS", "XXS", "XS", "S", "M", "L", "XL", "XXL", "XXXL"];

const FRAME_BASE_MARGIN = 450;

class ProductUtil {

     //Note: Reference => https://stackoverflow.com/questions/44756505/how-to-calculate-pixels-per-inch-of-an-image-in-different-dpi
    static computeFrameAvailableSizes(imgWidth, imgHeight) {
        const maxDPI = ProductUtil._computeMaxDPI(imgWidth);
        const minDPI = 100;
        let interval = Math.ceil((maxDPI - minDPI)/FRAME_SIZE_TYPES.length);
    
        const possibleSizes = {};
        let sizeTypesIndex = 0;

        var d = maxDPI;
        while(d >= minDPI) {
            const widthInches =  imgWidth / d;  
            const heightInches =  imgHeight / d;
            
            if(Math.max(widthInches, heightInches) < 5) {
                d -= interval;
                continue;
            }
                
            const sizeType = FRAME_SIZE_TYPES[sizeTypesIndex];

            if(!sizeType)
                break;
                
            possibleSizes[sizeType] = ProductUtil.createFrameSizeObject(widthInches, heightInches, d);
            
            sizeTypesIndex++;

            if((d - interval) < minDPI) {
                const remainingSizes = FRAME_SIZE_TYPES.length - sizeTypesIndex;
                interval = Math.ceil((d - 100)/remainingSizes);
                
                if(interval === 0)
                    break;

                d -= interval;
            } else {
                d -= interval;
            }
        }

        return possibleSizes;
    }

    static _computeMaxDPI(imgWidth) {
        let widthInches = imgWidth * INCH_PER_PIXEL;
        let maxDpi = imgWidth/widthInches;

        if(widthInches < 5) {
            while(widthInches < 5) {
                widthInches++;
                maxDpi = imgWidth/widthInches;
            }
        } else {
            while(widthInches >= 5) {
                widthInches--;
                maxDpi = imgWidth/widthInches;
            }
        }
        

        return Math.floor(maxDpi);
    }

    static createFrameSizeObject(widthInches, heightInches, dpi) {
        const label = widthInches.toFixed(2)+"\" x "+heightInches.toFixed(2)+"\"";
    
        const prices = ProductUtil.computeFrameCost(widthInches, heightInches);
        const priceAddition = prices[0] - frameProductType.basePrice;
        const marginAddition = prices[1] - FRAME_BASE_MARGIN;
    
        return {"label": label, "shortLabel": label, "priceAddition": priceAddition, "marginAddition": marginAddition, "dpi": dpi, "widthInches": widthInches, "heightInches": heightInches};
    }

    static computeFrameCost(width, height) {
        const w = Math.ceil(width) + 2;
        const h = Math.ceil(height) + 2;
    
        const noOfSqrFeet = Math.ceil((width * height)/(144));
        const glassCost = noOfSqrFeet * 200;
        const frameCost = (w + h) * 10 * 2;
        const photoCost = (noOfSqrFeet === 1? 50: 250) * Math.ceil(noOfSqrFeet/2.0);
        const deliveryCost = 300 * Math.ceil(noOfSqrFeet/2.0);
        const packagingCost = 50 * Math.ceil(noOfSqrFeet/2.0);
        const operationCost = 100;
        let totalCost = glassCost + frameCost + photoCost + deliveryCost + packagingCost + operationCost;
        
        let margin;
        const maxLength = Math.max(width, height);
        if(maxLength > 18) {
            margin = totalCost;
            totalCost += margin;
        } else if(maxLength > 12) {
            margin = 0.35 * totalCost;
            totalCost += margin;
        } else {
            margin = FRAME_BASE_MARGIN;
            totalCost *= 1.25;
        };

        return [Math.ceil(totalCost/10) * 10, margin];
    }
    

    static getProductVariantKey(productVariant) {
        return productVariant.variantLabel.replaceAll(" ", "").toLowerCase();
    }

    static getSelectedVariants(productVariants, selectedVariantIds) {
        if(!productVariants) return [];
        if(!selectedVariantIds) return [];
        
        const variantsById = {};
        productVariants.forEach(pv => {
                pv.variants.forEach(vr => {
                    variantsById[vr.variantId] = vr;
                });
        });

        const selectedVariants = selectedVariantIds.map(id => variantsById[id]).filter(vr => vr !== null);
        return selectedVariants;
    }
}

export default ProductUtil;


// WEBPACK FOOTER //
// ./src/util/ProductUtil.js